import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { bookingDays } from "../../../utils/apis/ev_bookings";
import { canAskSpaces, Editing, monthDays, Spaces, SpacesAsk, spacesFor } from "../../../utils/apis/availability";
import { DayNotes } from "../inputs/dayNotes";
import { ParkingSpace } from "./bookingForm";

// Free spaces, as the create and edit sheets show them.

// Each day's free spaces for a calendar month at the given hours: one question per month.
export const useMonthSpaces = (person: SpacesAsk | undefined, month: Date | undefined,
    start: string, end: string, hoursValid: boolean, editing?: Editing) => useQuery({
    queryKey: ['spaces', person?.capacityTenantId, person?.companyId, person?.userId, start, end, 'month', month ? DateTime.fromJSDate(month).toFormat("yyyy-MM") : null,
        editing?.bookingId ?? null, editing?.wholeSeries ?? null],
    queryFn: () => spacesFor(person!, monthDays(month!, (from, to) => bookingDays(from, to, start, end, true)), { perDay: true, editing }),
    enabled: Boolean(month && canAskSpaces(person) && hoursValid),
    staleTime: 60_000,
}).data;

// "Full" or "N left" under each day, for one parking type, from the months asked about.
export const notesFrom = (months: (Spaces | null | undefined)[], space: ParkingSpace): DayNotes => (date: Date) => {
    const day = DateTime.fromJSDate(date).toFormat("yyyy-MM-dd");
    const pool = months.flatMap((month) => month?.days ?? []).find((entry) => entry.startTime.startsWith(day))?.[space === "EV" ? "ev" : "standard"];
    return pool && pool.offered ? { text: pool.available === 0 ? "Full" : `${pool.available} left`, full: pool.available === 0 } : undefined;
};

// What the parking type card says about free spaces for the chosen dates and hours.
export const spacesLine = (spaces: Spaces | null | undefined, space: ParkingSpace, checking: boolean, unknown: boolean) => {
    if (checking) return "Checking availability…";
    if (unknown) return "Availability unknown";
    const pool = spaces?.[space === "EV" ? "ev" : "standard"];
    if (!pool) return undefined;
    return pool.available === 0 ? "No spaces available" : `${pool.available} space${pool.available === 1 ? "" : "s"} available`;
};
